module.exports = __webpack_public_path__ + "media/3_6-1.4e2a496c.mp3";